<template>
  <div style = "height:100%;display:flex;align-items:center;">{{value}}</div>
</template>

<script>
export default {
    props: {
        value: ''
    }
}
</script>

<style>

</style>